var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterExpandTabletBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.134,
    height: 16.453,
    viewBox: "0 0 22.134 16.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29966",
    "data-name": "Group 29966",
    transform: "translate(-287.835 -198.346)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17256",
    "data-name": "Path 17256",
    d: "M0,0H2.453V22.134H0Z",
    transform: "translate(309.969 198.346) rotate(90)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17268",
    "data-name": "Path 17268",
    d: "M0,0H2.453V22.133H0Z",
    transform: "translate(309.969 205.346) rotate(90)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17269",
    "data-name": "Path 17269",
    d: "M0,0H2.453V22.134H0Z",
    transform: "translate(309.969 212.346) rotate(90)",
    fill: "#EB1700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterExpandTabletBtn);
export default __webpack_public_path__ + "static/media/filter-expand-tablet-btn.4abbcd9698545cd58f46bfe8bb41145d.svg";
export { ForwardRef as ReactComponent };